<template>
  <b-card no-body>
    <b-card-body class="d-flex justify-content-between align-items-center">
      <div class="truncate">
        <h2
          class="mb-25 font-weight-bolder"
        >
          {{ cardValue | toNumber }}
        </h2>
        <span>{{ cardLabel }}</span>
      </div>
      <b-avatar
        :variant="cardColor"
        size="45"
      >
        <feather-icon
          size="21"
          :icon="cardIcon"
        />
      </b-avatar>
    </b-card-body>
  </b-card>
</template>
<script>
import { BCard, BCardBody, BAvatar } from 'bootstrap-vue'

export default {
  name: 'CounterCard',
  components: {
    BCard,
    BCardBody,
    BAvatar,
  },
  props: {
    cardValue: {
      type: Number,
      required: true,
    },
    cardLabel: {
      type: String,
      required: true,
    },
    cardIcon: {
      type: String,
      required: true,
    },
    cardColor: {
      type: String,
      required: true,
    },
  },
}
</script>
